import { fetchJson } from "../../../lib/Fetching";

function fetchDataFieldNames({ company_id, company_branch_id }) {
  return fetchJson("/products/api/client_lists/data_field_names", {
    company_id,
    company_branch_id
  });
}

export { fetchDataFieldNames };
